module.exports = __webpack_public_path__ + "media/icons/suitcase-da56e2bd.svg";